/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { getSingleUnitOfMeasureConversionAsync } from '../actions/DataActionExtension.g';
import { IGetSingleUnitOfMeasureConversionResponse } from '../actions/DataServiceEntities.g';
import { generateCacheKey, getSelectedProductIdFromActionInput } from '@msdyn365-commerce-modules/retail-actions';

/**
 * GetUomConversion Input Action
 */
export class GetSingleUomConversionInput implements Msdyn365.IActionInput {
    public productId: number;
    public apiSettings: Msdyn365.ICommerceApiSettings;
    constructor(productId: number, apiSettings: Msdyn365.ICommerceApiSettings) {
        this.productId = productId;
        this.apiSettings = apiSettings;
    }

    public getCacheKey = () => generateCacheKey(this.apiSettings, { key: 'productId', value: `${this.productId}` });
    public getCacheObjectType = () => 'singleUomConversion';
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetSingleUomConversionData {
    uomConversion: IGetSingleUnitOfMeasureConversionResponse;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createGetSingleUomConversionInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    const context = args.requestContext;
    const appSettings = context.apiSettings;
    const productId = getSelectedProductIdFromActionInput(args);
    if (productId) {
        return new GetSingleUomConversionInput(parseInt(productId, 10), appSettings);
    }
    throw Error('Unable to create GetUomConversionInput, no productId found in the URL');
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: GetSingleUomConversionInput, ctx: Msdyn365.IActionContext): Promise<IGetSingleUomConversionData> {
    const res = await getSingleUnitOfMeasureConversionAsync({ callerContext: ctx }, input.productId);
    if (res) {
        return { uomConversion: res };
    }

    throw new Error('Unable to get product');
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetSingleUomConversionData>>action,
    id: 'GetSingleUomConversion',
    input: createGetSingleUomConversionInput
});
